import { useState, useEffect } from 'react';
import { performIssueGetRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';
import type { Role, TransformedRole } from '../../common/types.tsx';
import type { Error, State } from './types.tsx';
import { getFetchRolesURL, transformRoleIdToString } from './utils.tsx';

const useFetchRoles = (projectKeyOrId: string): State => {
	const [data, setData] = useState<TransformedRole[]>([]);
	const [error, setError] = useState<Error | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		(async () => {
			setLoading(true);
			try {
				const response: Role[] = await performIssueGetRequest(
					getFetchRolesURL(projectKeyOrId),
					undefined,
					'fields/role-picker/src/services/fetch-roles/index',
				);
				setLoading(false);
				setData(transformRoleIdToString(response));
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (httpError: any) {
				setLoading(false);
				setError(httpError.message);
			}
		})();
	}, [projectKeyOrId]);

	return { loading, error, data };
};

export default useFetchRoles;
